import React, {useEffect} from "react";
import ReactGA from "react-ga4";

const PageCredential = ({ title, description }) => {
    useEffect(() => {
        document.title = "Crowdbees | " + title;
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription && description) 
        {
            metaDescription.setAttribute('content', description);
        }

        if(process.env.NODE_ENV === 'production')
        {
            ReactGA.initialize([
                {
                    trackingId: "G-XGZZDNL317",
                }
            ]);
        }

        window.scrollTo(0, 0);

        
    }, [title, description]);

    useEffect(() => {
        

    }, []);
  
    return (
        <></>
    );
};

export {PageCredential};